import { render, staticRenderFns } from "./NewArticles.vue?vue&type=template&id=525d8da8&scoped=true"
import script from "./NewArticles.vue?vue&type=script&lang=js"
export * from "./NewArticles.vue?vue&type=script&lang=js"
import style0 from "./NewArticles.vue?vue&type=style&index=0&id=525d8da8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "525d8da8",
  null
  
)

export default component.exports